<template>
  <div class="report-graphs">
    <div class="sf-grid report-grid sf-grid-wide sf-below-4">
      <div
        class="sf-row sf-row-eq-height"
        :class="{ 'sf-row-center': oneGraph }"
      >
        <sf-graph
          v-for="graph in reportGraphs"
          :key="graph.id"
          v-bind="graph"
        ></sf-graph>
      </div>
    </div>
  </div>
</template>

<script>
import SfGraph from './sf-graph'

const ReportsGraphsList = {
  props: {
    reportGraphs: {
      type: Array,
      required: true,
    },
  },
  components: {
    SfGraph,
  },
  computed: {
    oneGraph() {
      return this.reportGraphs.length === 1
    },
  },
}

export default ReportsGraphsList
</script>
